import React from 'react';
import styled, { css } from 'styled-components';
import colors from 'src/integration/styles/colors';

interface RadioOption<T extends string> {
  value: T;
  label: string;
}

interface ComponentProps<T extends string> {
  options: RadioOption<T>[];
  name: string;
  selectedValue: T;
  onChange: (value: T) => void;
}

const Root = styled.div`
    display: flex;
    gap: 16px;
`;

const Label = styled.label`
    display: flex;
    align-items: center;
    cursor: pointer;
    color: ${colors.primaryDarkJungleGreen};
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
`;

const HiddenRadio = styled.input`
    display: none;
`;

const CustomRadio = styled.span<{ $checked: boolean }>`
    ${({ $checked }) => css`
        width: 18px;
        height: 18px;
        border: 1px solid ${colors.grey2};
        border-radius: 50%;
        display: inline-block;
        position: relative;
        margin-right: 8px;

        ${$checked &&
        css`
            //background-color: ${colors.chart.carminePink};
            border: 1px solid ${colors.chart.carminePink};

            &::after {
                content: '';
                width: 10px;
                height: 10px;
                background: ${colors.chart.carminePink};
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        `}
    `}
`;

const CustomRadioGroup = <T extends string>({ options, name, selectedValue, onChange }: ComponentProps<T>) => {
  return (
    <Root>
      {options.map((option) => (
          <Label key={option.value}>
            <HiddenRadio
              type="radio"
              name={name}
              value={option.value}
              checked={selectedValue === option.value}
              onChange={() => onChange(option.value)}
            />
            <CustomRadio $checked={selectedValue === option.value} />
              {option.label}
          </Label>
      ))}
  </Root>
  );
};

export default CustomRadioGroup;
